module.exports = __webpack_public_path__ + "img/pr-5.fe749611.png";